// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../Assets/PageNotFoundImages/banner_bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../Assets//PageNotFoundImages/banner_left.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../Assets/PageNotFoundImages/banner_right.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quickvee-single-store-main-area-detail-page {
  margin-left: 250px !important;
}

.SingleStoreAllInformationPage .slick-slider {
  margin-left: 0;
  margin-right: 0;
}

.cancleBtn-div {
  margin-top: 10px;

  display: flex;
  align-self: flex-end;
}

.cancleBtn-div {
  display: none !important;
}

@media (max-width: 1200px) {
  .quickvee-single-store-top-bar > .quickvee-logo-icon-single-store {
    /* width: auto; */
    margin-right: 10px;
    margin-left: -6px;
  }
}

.cancleBtn-div-main-order > div {
  display: flex;
  align-items: flex-end;
  /* border: 1px solid 1px red !important; */
  height: 20px !important;
}

.cancleBtn-div-main-order {
  display: none !important;
}
/* .swpier_main_div_SingleProductListing{
  margin-left: -25px;
  margin-right: -25px;
}
.swpier_main_div_SingleProductListing_inner_div{
  padding-left: 25px !important;
} */
@media (max-width: 768px) {
  .css-13xqbvb {
    top: 5px !important;
    right: 7px !important;
  }
  .quickvee-customer-login-main {
    /* width: 75px; */
  }
  .delivery-address-main-div {
    display: flex !important;
    flex-wrap: wrap;
  }
  .delivery-address-inner-div {
    margin: 0px 0px 15px 0px !important;
  }
  .quickvee-single-product-image-section {
    margin: 20px 20px 0px 0px;
  }
  .css-1e6y48t-MuiButtonBase-root-MuiButton-root {
    /* margin-left: 10px !important; */
  }
  .quickvee-single-store-main-area-detail-page {
    margin-left: 0 !important;
  }

  .quickvee-single-product-image-section {
    /* margin: 0px 0px 20px 20px; */
  }

  .quickvee-single-store-left-menu {
    width: 250px;
    position: fixed;
    z-index: 999;
    top: -9px;
    height: 100vh;
    padding-bottom: 70px;
    left: 0;
    transition: all 0.3s;
    overflow-x: auto !important;
    /* overflow: hidden !important; */
  }

  .cancleBtn-div {
    display: block !important;
  }

  .quickvee-single-store-top-bar > .quickvee-logo-icon-single-store {
    width: auto;
  }

  /* .quickvee-single-store-search-bar {
        display: none !important;
    }

    .quickvee-single-store-top-bar>.quickvee-logo-icon-single-store {
        width: unset !important;

    } */
  .quickvee-store-topbar-cart {
    width: unset !important;
    /* padding-bottom: 100px; */
  }

  .quickvee-store-cart-items {
    padding-bottom: 100px;
  }

  .modal-view-full-hours-div {
    width: 90%;
  }

  .modal-view-full-hours-description {
    /* margin-top: 50px; */
    /* height: 100%; */
    /* overflow-y: auto !important; */
  }

  .cancleBtn-div-main-order {
    display: flex !important;
    align-items: flex-end !important;
  }

  .cancleBtn-div-main-order > div {
    /* align-items: flex-end; */

    margin: 10px;
    width: 20px;
  }
}

.quickvee-store-cart-items {
  padding-bottom: 100px;
}

.modal-view-full-hours-description {
  overflow-y: auto !important;
  max-height: 78vh;
  scroll-behavior: smooth;
}

.modal-view-full-hours-description::-webkit-scrollbar {
  width: 3px !important;
}

.modal-view-full-hours-description::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

.modal-view-full-hours-description::-webkit-scrollbar-thumb {
  background: #3e85f8 !important;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

.modal-view-full-hours-description::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.cancleBtn-div-main-order > div {
  /* justify-self: flex-end; */
  margin: 10px;
  width: 20px;
}

@media (min-width: 769px) {
  .quickvee-single-store-logo-singleStore {
    display: none !important;
  }
}

.quickvee-single-store-logo-singleStore {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.quickvee-single-store-logo-singleStore a img {
  object-fit: contain;
  object-position: center;
  border-radius: 100px;
  border: 2px solid #f2f2f2;
  overflow: hidden;
  text-align: center;
  padding: 10px;
  position: relative;
  width: 75px;
  height: 75px;
  left: 0px;
  top: 0px;
  transition: all 0.5s;
}

.quickvee-single-store-main-area-detail-page {
  display: block !important;
}

.quickvee-single-store-pickup-delivery {
  display: flex;
  align-items: center;
  justify-content: space-around;
  /* width: 100%; */
  background: #efefef;
  border-radius: 5px;
  /* padding: 5px 10px; */
}

.quickvee-single-store-pickup-delivery > Button {
  /* width: 100%; */
  /* padding: 3px 25px; */
  width: 120px;
  background-color: #efefef;
  color: #928c8c;
  font-size: 15px;
  text-transform: capitalize !important;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-pickup-delivery > .active-delivery-button {
  background: #000 !important;
  color: #ffffff !important;
  font-size: 15px;
  height: 44px;
  font-family: QuicksandMedium !important;
  box-shadow: 0px 6px 12px #00000042;
}

.quickvee-single-store-content-singleStore > span {
  display: flex;
  align-items: center;
  color: #232323;
  text-transform: capitalize;
  font-size: clamp(10px, 0.05px + 5.1783vw, 18px) !important;
  /* text-align: center; */
  font-family: QuicksandBold !important;
}

@media (max-width: 652px) {
  .quickvee-single-store-logo-singleStore {
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
  }

  .quickvee-single-store-pickup-delivery {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

@media (max-width: 612px) {
  .q-sv-single-product {
    width: 180px !important;
    /* height: 250px !important; */
  }

  /* .quickvee-single-store-content-singleStore>span {
        font-size: 20px;
    } */

  .quickvee-single-store-content-singleStore > p {
    font-size: clamp(10px, 0.05px + 5.1783vw, 14px) !important;
  }

  .single-store-sproductListing-section > section > span {
    font-size: 20px;
  }

  .single-store-sproductListing-section > section {
    margin-bottom: 0;
  }
}

.store-open-close-status {
  border-radius: 12px;
  color: #fff;
  font-family: QuicksandMedium !important;
  text-transform: uppercase;
  padding: 2px 10px;
  font-size: 13px;
  margin-left: 10px;
  /* margin-top: -12px; */
  z-index: 1;
}

.Swiper-btn {
  font-size: 80% !important;
  width: 90px;
  /* margin-right: 10px; */
}

.mySwiper-catagories-swiper-single-store {
  margin-bottom: 20px;
  margin-left: -20px;
  padding-left: 20px;
  margin-right: -20px;
  padding-left: 20px;
}

@media (max-width: 768px) {
  .q-sv-single-product-bottom-purchase {
    position: absolute;
    top: 5px;
    left: 0;
    display: flex !important;
    flex-direction: row-reverse;
    /* transform: translate(-50%, -50%) !important; */
  }

  .modal-form-single-item {
    /* margin-bottom: 15px !important; */
  }

  .delivery-address-update-form {
    /* margin-bottom: 15px; */
    /* display:flex !important;
    flex-wrap: wrap; */
  }
  .delivery-address-update-form-city-zipCode {
    display: flex !important;
    flex-wrap: wrap;
  }
  .modal-form-single-item-city {
    margin: 0px 0px 15px 0px !important;
    width: 100%;
  }
  .modal-form-single-item-zipcode {
    width: 100%;
  }

  .q-sv-single-product-bottom-purchase {
    position: absolute;
    top: 0px;
    left: 0;
    display: flex !important;
    flex-direction: row-reverse;
    /* transform: translate(-50%, -50%) !important; */
  }

  .q-sv-single-product {
    padding-top: 45px;
    /* padding-bottom: 45px !important; */
  }

  .q-sv-single-product > .q-sv-single-product-bottom {
    display: flex !important;
    flex-direction: column-reverse;
    /* margin-top: 20px; */
  }

  .q-sv-single-product > span {
    position: absolute !important;
    bottom: 67px !important;
    top: unset !important;
    margin-left: 10px;
    height: 20px;
    width: 60px;
    font-size: 10px;
    padding-top: 3px;
  }

  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > Button {
    width: 100px !important;
    font-size: 11px;
    background: none;
    margin-left: 0 !important;
    margin-right: -25px;
    height: 36px !important;
  }

  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > Button
    p {
    margin-left: 0;
  }

  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > .product-qti-button {
    width: 58%;
    margin-right: 11px;
    /* margin-top: 5px; */
  }

  .out-of-stock-btn {
    margin-right: 10px !important;
    margin-top: 5px !important;
    border: 5px solid black;
  }

  .home-page-all-sections {
    width: 94% !important;
  }

  .header_area_box {
    width: 94% !important;
  }

  .media-scroller-upper {
    margin-left: -25px !important;
    padding-left: 25px !important;
    margin-right: -25px !important;
    padding-right: 25px !important;
  }

  .SingleStoreAllInformationPage .media-scroller-upper {
    margin-right: 0 !important;
  }

  .q-sv-single-product > .q-sv-single-product-top {
    width: 100% !important;
    margin-top: 5px;
  }

  .q-sv-single-product > .q-sv-single-product-top > img {
    height: 100%;
  }

  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > .add-wish {
    background: unset;
  }

  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-amount
    > span {
    font-size: 15px;
  }

  .q-sv-single-product > .q-sv-single-product-bottom > h1 {
    font-size: 12px;
  }

  .quickvee-single-store-content-singleStore {
    margin-left: 5px;
  }

  .quickvee-single-store-content-singleStore > span {
    font-size: 20px;
  }

  .quickvee-single-store-content-singleStore > p {
    font-size: clamp(12px, 0.05px + 3.1783vw, 16px) !important;
  }

  .single-store-sproductListing-section > section > span {
    font-size: clamp(16px, 0.05px + 4.1783vw, 20px) !important;
  }

  .single-store-sproductListing-section {
    margin-bottom: 20px;
  }

  .single-store-sproductListing-section > section {
    margin-bottom: 5px;
  }

  .songleStoreSearchBar {
    margin-top: -10px;
    margin-left: -25px;
    margin-right: -25px;
  }

  .q-sv-single-product-bottom-purchase
    > .product-qti-button
    > .add-remove-cart-btn {
    background: #0a64f9 !important;
    border: none !important;
    padding: 4px 5px !important;
  }

  .single-product-card-add-btn {
    background: #0a64f9 !important;
    border: none !important;
    padding: 14px 5px !important;
    height: 28px;
    border-radius: 4px;
  }

  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > .product-qti-button {
    height: auto;
    width: 10px;
    padding: 0px;
    /* border: 1px solid #0a64f9; */
    border: 0;
  }

  .select-box {
    z-index: 1;
  }

  .product-in-category {
    padding-left: 5px;
    padding-right: 5px;
  }

  .modal-view-full-hours-description > .full-hours-data > div > span {
    font-size: clamp(5, 0.05px + 3.1783vw, 16px);
  }

  .modal-view-full-hours-description > .full-hours-data > div > p {
    font-size: clamp(5px, 0.05px + 3.1783vw, 16px);
  }

  .modal-view-full-hours-description > .full-hours-data .view-hour-today p {
    font-size: clamp(5px, 0.05px + 3.1783vw, 16px);
    display: -webkit-inline-box;
  }
  .select-box__input-text {
    font-size: clamp(8px, 0.05px + 3.1783vw, 16px) !important;
  }

  .select-box__option {
    font-size: clamp(8px, 0.05px + 3.1783vw, 16px) !important;
  }

  .single-selectCategory-product-listing > .q-single-category-headings > span {
    font-size: clamp(12px, 0.05px + 5.1783vw, 20px) !important;
  }

  .order-top-bar-search {
    width: 100%;
  }

  /* #modal-view-full-hours-header {
    position: sticky !important;
    top: 0;
    background-color: white;
  } */

  .topBarUserAndCartLogo {
    display: flex !important;
    flex-direction: row-reverse;
    /* border: solid 1px red; */
    justify-content: center !important;
  }

  .select-box {
    width: 220px;
  }

  .quickvee-single-store-logo-singleStore a img {
    height: 60px;
    width: 60px;
  }

  .quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn {
    margin: 0;
    width: 100%;
    padding: 10px;
  }

  .full-hours-data-detail > .single-full-hour-data-detail > img {
    width: 50px;
    height: 50px;
  }

  .full-hours-data-detail > .single-full-hour-data-detail > span {
    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;
    text-align: center;
  }

  .full-hours-data-detail > .single-full-hour-data-detail > p {
    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;
    text-align: center;
    color: #232323;
    font-size: 18px !important;
    /* font-family: QuicksandBold !important; */
    margin-left: 14px;
    font-weight: 600;
    font-family: Jost;
    text-wrap-style: balance;
  }

  .modal-view-full-hours-description
    > .full-hours-data-detail
    > .single-full-hour-data-detail {
    padding: 10px;
  }

  .order-side-bar-component {
    top: 0;
    z-index: 100;
  }

  .quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > a,
  .quickvee-store-topbar-cart
    > .quickvee-store-cart-checkout-btn
    > .payment-checkout-with-login {
    width: 100%;
  }

  .quickvee-store-topbar-cart {
    padding-left: 10px;
  }

  .orderSummeryBannerContent {
    right: unset !important;
    left: 10%;
    width: unset !important;
    font-size: clamp(18px, 0.5px + 2.1783vw, 20px);
  }

  .OrderSummeryProductRTop h4 {
    font-size: clamp(15px, 0.5px + 2.1783vw, 18px) !important;
  }

  .OrderSummeryProductRBottomL span {
    font-size: clamp(18px, 0.5px + 2.1783vw, 20px) !important;
  }

  .orderSummeryRightTopC p {
    margin-bottom: 12px !important;
  }

  .button-for-minamount-on-delivery {
    width: 100%;
  }

  .full-hours-data-detail > .single-full-hour-data-detail > img {
    width: 50px;
    height: 50px;
  }

  .full-hours-data-detail > .single-full-hour-data-detail > span {
    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;
    text-align: center;
  }

  .full-hours-data-detail > .single-full-hour-data-detail > p {
    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;
    text-align: center;
    color: #232323;
    font-size: 18px !important;
    /* font-family: QuicksandBold !important; */
    margin-left: 14px;
    font-weight: 600;
    font-family: Jost;
    text-wrap-style: balance;
  }

  .modal-view-full-hours-description
    > .full-hours-data-detail
    > .single-full-hour-data-detail {
    padding: 10px;
  }

  .order-side-bar-component {
    top: 0;
    z-index: 100;
  }

  .quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > a {
    width: 100%;
  }

  .quickvee-store-topbar-cart {
    padding-left: 10px;
  }

  .orderSummeryBannerContent {
    /* right: unset !important; */
    /* left: 10%; */
    width: 65% !important;
    font-size: clamp(18px, 0.5px + 2.1783vw, 20px);
  }

  .orderSummeryBannerContent p {
    font-size: 16px;
  }

  .OrderSummeryProductRTop h4 {
    font-size: clamp(15px, 0.5px + 2.1783vw, 18px) !important;
  }

  .OrderSummeryProductRBottomL span {
    font-size: clamp(18px, 0.5px + 2.1783vw, 20px) !important;
  }

  .orderSummeryRightTopC p {
    margin-bottom: 12px !important;
  }

  .button-for-minamount-on-delivery {
    width: 100%;
  }
}

@media (max-width: 612px) {
  .q-sv-single-product {
    width: 100% !important;
    height: 300px !important;
  }
}

.add-btn-single-product {
  /* margin-right: 5px; */
  /* width: 30px; */

  color: #efefef;
  background-color: #0a64f9;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.quickvee-single-store-logo-singleStore {
  margin-top: 20px;
  margin-bottom: 10px;
}

@media (max-width: 420px) {
  .quickvee-single-store-pickup-delivery {
    width: 100%;
  }

  .quickvee-single-store-pickup-delivery > Button {
    width: 180px;
  }

  .select-box {
    width: 60%;
  }

  .modal-view-full-hours-description
    > .full-hours-data-detail
    > .single-full-hour-data-detail {
    padding: 5px;
  }
}

@media (max-width: 900px) {
  .q-sv-single-product .single-p-select-variant-btn {
    width: 70%;
    padding: 0;
  }
}

@media (max-width: 806px) {
  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > Button
    p {
    font-size: 14px !important;
  }
}
@media (max-width: 480px) {
  .StoreCredit-zone-detail-section {
    padding-top: 0px;
    padding-left: 0%;
    padding-right: 0;
  }

  .single-store-sproductListing-section > section > div > a {
    font-size: clamp(8px, 0.05px 2.1783vw, 16px) !important;
    /* width: 90px !important; */
    white-space: nowrap;
  }

  .account-info-main-component {
    padding: 15px 0px;
  }

  .account-info-welcome-header {
    margin: 0px 15px;
  }

  .account-info-subheading > p {
    margin: 0px 15px;
  }

  .account-info {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    border-radius: 0;
    margin: 12px -2px;
  }

  .StoreCredit-zone-detail-section {
    border: none;
  }
}

/* @media (max-width:441px) {
    .single-store-sproductListing-section>section>div>a {
        font-size: 10px !important;
    }
} */

.search-category-page-store-description {
  /* width: auto !important; */
  /* max-width: 170px !important; */
  width: auto !important;
}

@media (max-width: 440px) {
  .search-category-page-store-description > span {
    font-size: 15px;
  }

  .search-category-page-store-description > p {
    font-size: 10px;
  }

  .search-category-page-store-detail > .search-category-store-image-div {
    margin-right: 6px;
  }
}

.modal-view-full-hours-description {
  overflow-y: auto;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent black overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.quickvee-single-store-offer-coupon {
  /* width: 285px; */
}

.moble-cart-icon {
  margin-top: 4px;
  margin-left: 10px;
  margin-right: 10px;
  width: 28px;
  /* margin-right: 20px !important; */
}

.css-106c1u2-MuiBadge-badge {
  top: 9px !important;
  right: 10px !important;
}

.quickvee-single-store-cart-button {
  background: #fff !important;
  border-radius: 6px !important;
  color: #232323 !important;
  cursor: pointer !important;
  font-family: QuicksandBold !important;
  font-size: 20px !important;
  line-height: normal !important;
  margin: 0 5px;
  padding: 6px 20px !important;
}

.q-sv-single-product > .q-sv-single-product-top > img {
  z-index: unset !important;
}

.quickvee-single-store-top-bar {
  display: flex !important;
  flex-wrap: nowrap;
}

.topBarUserAndCartLogo {
  display: flex !important;
  flex-wrap: nowrap !important;
  flex-direction: row-reverse;
}

@media (max-width: 950px) {
  .quickvee-single-store-offer-coupon {
    margin: 0;
  }

  .order-top-bar-search {
    width: unset !important;
  }
}

.single-product-zoom-div > div > div {
  /* background-size: 80% !important; */
  /* background-position: 50% !important; */
}

@media (max-width: 1104px) {
  .single-product-zoom-div > div > div {
    background-size: 80% !important;
    /* background-position: 50% !important; */
  }

  .quickvee-single-product-add-update > span {
    margin: 0;
  }

  .quickvee-single-product-add-update > span {
    width: 10%;
  }

  .quickvee-single-product-add-update {
    /* margin-left: px !important; */
  }

  .quickvee-single-product-add-update > .single-patc-btn,
  .quickvee-single-product-add-update > .single-patc-btn:hover {
    padding: 5px 11px !important;
  }
}

@media (max-width: 891px) {
  .single-product-zoom-div > div > div {
    background-size: 60% !important;
    /* background-position: 50% !important; */
  }

  .quickvee-single-product-add-update > .single-patc-btn,
  .quickvee-single-product-add-update > .single-patc-btn:hover {
    margin: 0 10px !important;
  }

  .quickvee-single-product-detail-section {
    margin-left: 0;
  }
}

.quickvee-single-product-add-update > .single-patc-btn,
.quickvee-single-product-add-update > .single-patc-btn:hover {
  font-size: clamp(2px, 5px + 0.7783vw, 14px) !important;
  /* margin: 0 10px; */
}

.single-product-single-features-selection > div > label {
  font-size: clamp(12px, 1px + 1.1783vw, 14px) !important;
}

@media (max-width: 850px) {
  .quickvee-single-product-add-update {
    margin-left: 0px !important;
    margin-right: -100px !important;
  }
}

.css-106c1u2-MuiBadge-badge {
  width: 20px;
}

@media (max-width: 480px) {
  .account-info-welcome-header {
    display: flex !important;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start !important;
  }

  .account-info-welcome-header p {
    /* margin-left: auto; */

    /* Add this line */
  }
}

.account-info-main-component > .account-info-welcome-header > h1 {
  font-size: clamp(15px, 2px + 4.1783vw, 25px) !important;
}

.css-1xhypcz-MuiStack-root > .MuiTextField-root {
  padding-bottom: 5px !important;
}

#modal-modal-description {
  padding-bottom: 70px;
}
.modal-Billinginfo {
  padding-bottom: 80px !important;
}

#modal-modal-description::-webkit-scrollbar {
  width: 3px;
}

/* Track */
#modal-modal-description::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;

  cursor: pointer;
}

/* Handle */
#modal-modal-description::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
#modal-modal-description::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.basic-modal > .modal-forms > .modal-footer {
  padding: 15px;
  /* margin-left: 12px;
  margin-right: 18px; */
  background: white;
  position: fixed !important;
  left: 0;
  bottom: 0;
  z-index: 1;
}

@media (max-width: 490px) {
  .quickvee-single-product-top-section {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: center;
  }

  .quickvee-single-product-top-section > div {
    flex: 1 1;
    /* Make the divs flexible to distribute space */
    display: flex;
    /* Nested flex container */
  }

  .quickvee-single-product-detail-section {
    align-self: start !important;
  }

  .quickvee-single-product-image-section {
    width: 100%;
    /* margin-left: 10px; */
    margin: 0;
  }

  .single-product-single-features-selection > div > label {
    font-size: 18px !important;
    padding: 7px 14px;
  }

  .quickvee-single-product-add-update {
    margin-right: 0 !important;
  }

  .quickvee-single-product-add-update > .single-patc-btn,
  .quickvee-single-product-add-update > .single-patc-btn:hover {
    font-size: 13px !important;
    margin: 0 20px !important;
  }

  .quickvee-single-product-single-features {
    /* margin: -6px; */
  }

  .single-product-single-features-selection > div > input {
    height: 0;
  }

  .quickvee-single-product-detail-section {
    margin: 0;
  }

  .go-to-cart-btn {
    padding: 10px 20px !important;
  }
}

.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.MuiSelect-select {
  min-height: 1.543em !important;
}

.discount-tag {
  z-index: 1;
}

.id-type-billinginfo {
  height: 3.1rem !important;
  margin-top: 1px !important;
}

.password-title-accountinfo {
  text-transform: capitalize;
  color: #212121;
  font-size: 16px;
  font-family: QuicksandBold, 'Quicksand' !important;
}

.last-change-password-p {
  text-transform: capitalize;
  color: #707070 !important;
  font-size: 12px;
  font-family: QuicksandSemiBold, 'Quicksand' !important;
}

.date-of-birth-div {
  margin-bottom: 0 !important;
}

@media (max-width: 420px) {
  .out-of-stock-btn {
    height: 36px !important;
  }
}

.dropdown-container > button {
  background-color: white !important;
  border: none !important;
}
.DropDown-menu-container {
  border-radius: 8px;
  box-shadow: 0px 6px 15px #0a64f94d;
  padding: 0 !important;
}
.dropdown-toggle::after {
  display: none !important;
}

.error_banner_area {
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: bottom;
  position: relative;
  background-repeat: no-repeat;
  min-height: calc(100vh - 0px);
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .error_banner_area {
  }
}

.error_banner_left {
  width: 20%;
  height: auto;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-repeat: no-repeat;
}

.error_banner_right {
  width: 20%;
  height: auto;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-repeat: no-repeat;
}

.error_banner_center {
  width: 40%;
  height: auto;
  margin: 0 auto;
  /* padding-top: 13%; */
  text-align: center;
}

element.style {
  filter: invert(0);
}
.error_banner_center img {
  width: 40%;
  height: auto;
  margin-bottom: 20px;
}

@media (max-width: 1280px) {
  .error_banner_left,
  .error_banner_right {
    width: 23%;
  }
}
@media (max-width: 991px) {
  .error_banner_left {
    background-position: right;
  }
  .error_banner_right {
    background-position: left;
  }
  .error_banner_center {
    width: 50%;
  }
}

@media (max-width: 480px) {
  .error_banner_left,
  .error_banner_right {
    width: 36%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/customSingleStore.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;AACA;;;;;;GAMG;AACH;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,OAAO;IACP,oBAAoB;IACpB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;;;;;;;OAOK;EACL;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;;IAE3B,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,0DAA0D;EAC1D,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;;OAEK;;EAEL;IACE,0DAA0D;EAC5D;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,wBAAwB;IACxB,2BAA2B;IAC3B,iDAAiD;EACnD;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;IACzB;sBACkB;EACpB;EACA;IACE,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,mCAAmC;IACnC,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,wBAAwB;IACxB,2BAA2B;IAC3B,iDAAiD;EACnD;;EAEA;IACE,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;IAIE,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;;;;IAKE,cAAc;EAChB;;EAEA;;;;IAIE,UAAU;IACV,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;;;IAIE,iBAAiB;EACnB;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;IAGE,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;;;IAIE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;EACA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;IACE,WAAW;EACb;;EAEA;;;;KAIG;;EAEH;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wDAAwD;IACxD,kBAAkB;EACpB;;EAEA;IACE,wDAAwD;IACxD,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,2CAA2C;IAC3C,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,MAAM;IACN,YAAY;EACd;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,8CAA8C;EAChD;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wDAAwD;IACxD,kBAAkB;EACpB;;EAEA;IACE,wDAAwD;IACxD,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,2CAA2C;IAC3C,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,MAAM;IACN,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,eAAe;IACf,qBAAqB;IACrB,8CAA8C;EAChD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;AACF;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;;EAEjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uDAAuD;IACvD,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;0CACsC;IACtC,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;;;GAIG;;AAEH;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE;IACE,+BAA+B;IAC/B,yCAAyC;EAC3C;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,yCAAyC;EAC3C;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,2BAA2B;IAC3B,+BAA+B;EACjC;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;;IAEvB,kBAAkB;EACpB;AACF;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb;uBACqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,+CAA+C;IAC/C,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mDAAgE;EAChE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;EACA;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,mDAAmE;EACnE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,mDAAmE;EACnE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF","sourcesContent":[".quickvee-single-store-main-area-detail-page {\n  margin-left: 250px !important;\n}\n\n.SingleStoreAllInformationPage .slick-slider {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.cancleBtn-div {\n  margin-top: 10px;\n\n  display: flex;\n  align-self: flex-end;\n}\n\n.cancleBtn-div {\n  display: none !important;\n}\n\n@media (max-width: 1200px) {\n  .quickvee-single-store-top-bar > .quickvee-logo-icon-single-store {\n    /* width: auto; */\n    margin-right: 10px;\n    margin-left: -6px;\n  }\n}\n\n.cancleBtn-div-main-order > div {\n  display: flex;\n  align-items: flex-end;\n  /* border: 1px solid 1px red !important; */\n  height: 20px !important;\n}\n\n.cancleBtn-div-main-order {\n  display: none !important;\n}\n/* .swpier_main_div_SingleProductListing{\n  margin-left: -25px;\n  margin-right: -25px;\n}\n.swpier_main_div_SingleProductListing_inner_div{\n  padding-left: 25px !important;\n} */\n@media (max-width: 768px) {\n  .css-13xqbvb {\n    top: 5px !important;\n    right: 7px !important;\n  }\n  .quickvee-customer-login-main {\n    /* width: 75px; */\n  }\n  .delivery-address-main-div {\n    display: flex !important;\n    flex-wrap: wrap;\n  }\n  .delivery-address-inner-div {\n    margin: 0px 0px 15px 0px !important;\n  }\n  .quickvee-single-product-image-section {\n    margin: 20px 20px 0px 0px;\n  }\n  .css-1e6y48t-MuiButtonBase-root-MuiButton-root {\n    /* margin-left: 10px !important; */\n  }\n  .quickvee-single-store-main-area-detail-page {\n    margin-left: 0 !important;\n  }\n\n  .quickvee-single-product-image-section {\n    /* margin: 0px 0px 20px 20px; */\n  }\n\n  .quickvee-single-store-left-menu {\n    width: 250px;\n    position: fixed;\n    z-index: 999;\n    top: -9px;\n    height: 100vh;\n    padding-bottom: 70px;\n    left: 0;\n    transition: all 0.3s;\n    overflow-x: auto !important;\n    /* overflow: hidden !important; */\n  }\n\n  .cancleBtn-div {\n    display: block !important;\n  }\n\n  .quickvee-single-store-top-bar > .quickvee-logo-icon-single-store {\n    width: auto;\n  }\n\n  /* .quickvee-single-store-search-bar {\n        display: none !important;\n    }\n\n    .quickvee-single-store-top-bar>.quickvee-logo-icon-single-store {\n        width: unset !important;\n\n    } */\n  .quickvee-store-topbar-cart {\n    width: unset !important;\n    /* padding-bottom: 100px; */\n  }\n\n  .quickvee-store-cart-items {\n    padding-bottom: 100px;\n  }\n\n  .modal-view-full-hours-div {\n    width: 90%;\n  }\n\n  .modal-view-full-hours-description {\n    /* margin-top: 50px; */\n    /* height: 100%; */\n    /* overflow-y: auto !important; */\n  }\n\n  .cancleBtn-div-main-order {\n    display: flex !important;\n    align-items: flex-end !important;\n  }\n\n  .cancleBtn-div-main-order > div {\n    /* align-items: flex-end; */\n\n    margin: 10px;\n    width: 20px;\n  }\n}\n\n.quickvee-store-cart-items {\n  padding-bottom: 100px;\n}\n\n.modal-view-full-hours-description {\n  overflow-y: auto !important;\n  max-height: 78vh;\n  scroll-behavior: smooth;\n}\n\n.modal-view-full-hours-description::-webkit-scrollbar {\n  width: 3px !important;\n}\n\n.modal-view-full-hours-description::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.modal-view-full-hours-description::-webkit-scrollbar-thumb {\n  background: #3e85f8 !important;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n  outline: 1px solid #fff;\n}\n\n.modal-view-full-hours-description::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9;\n  cursor: pointer !important;\n}\n\n.cancleBtn-div-main-order > div {\n  /* justify-self: flex-end; */\n  margin: 10px;\n  width: 20px;\n}\n\n@media (min-width: 769px) {\n  .quickvee-single-store-logo-singleStore {\n    display: none !important;\n  }\n}\n\n.quickvee-single-store-logo-singleStore {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.quickvee-single-store-logo-singleStore a img {\n  object-fit: contain;\n  object-position: center;\n  border-radius: 100px;\n  border: 2px solid #f2f2f2;\n  overflow: hidden;\n  text-align: center;\n  padding: 10px;\n  position: relative;\n  width: 75px;\n  height: 75px;\n  left: 0px;\n  top: 0px;\n  transition: all 0.5s;\n}\n\n.quickvee-single-store-main-area-detail-page {\n  display: block !important;\n}\n\n.quickvee-single-store-pickup-delivery {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  /* width: 100%; */\n  background: #efefef;\n  border-radius: 5px;\n  /* padding: 5px 10px; */\n}\n\n.quickvee-single-store-pickup-delivery > Button {\n  /* width: 100%; */\n  /* padding: 3px 25px; */\n  width: 120px;\n  background-color: #efefef;\n  color: #928c8c;\n  font-size: 15px;\n  text-transform: capitalize !important;\n  transition: all 0.2s ease-in-out;\n}\n\n.quickvee-single-store-pickup-delivery > .active-delivery-button {\n  background: #000 !important;\n  color: #ffffff !important;\n  font-size: 15px;\n  height: 44px;\n  font-family: QuicksandMedium !important;\n  box-shadow: 0px 6px 12px #00000042;\n}\n\n.quickvee-single-store-content-singleStore > span {\n  display: flex;\n  align-items: center;\n  color: #232323;\n  text-transform: capitalize;\n  font-size: clamp(10px, 0.05px + 5.1783vw, 18px) !important;\n  /* text-align: center; */\n  font-family: QuicksandBold !important;\n}\n\n@media (max-width: 652px) {\n  .quickvee-single-store-logo-singleStore {\n    display: flex !important;\n    flex-direction: column;\n    align-items: center !important;\n  }\n\n  .quickvee-single-store-pickup-delivery {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n}\n\n@media (max-width: 612px) {\n  .q-sv-single-product {\n    width: 180px !important;\n    /* height: 250px !important; */\n  }\n\n  /* .quickvee-single-store-content-singleStore>span {\n        font-size: 20px;\n    } */\n\n  .quickvee-single-store-content-singleStore > p {\n    font-size: clamp(10px, 0.05px + 5.1783vw, 14px) !important;\n  }\n\n  .single-store-sproductListing-section > section > span {\n    font-size: 20px;\n  }\n\n  .single-store-sproductListing-section > section {\n    margin-bottom: 0;\n  }\n}\n\n.store-open-close-status {\n  border-radius: 12px;\n  color: #fff;\n  font-family: QuicksandMedium !important;\n  text-transform: uppercase;\n  padding: 2px 10px;\n  font-size: 13px;\n  margin-left: 10px;\n  /* margin-top: -12px; */\n  z-index: 1;\n}\n\n.Swiper-btn {\n  font-size: 80% !important;\n  width: 90px;\n  /* margin-right: 10px; */\n}\n\n.mySwiper-catagories-swiper-single-store {\n  margin-bottom: 20px;\n  margin-left: -20px;\n  padding-left: 20px;\n  margin-right: -20px;\n  padding-left: 20px;\n}\n\n@media (max-width: 768px) {\n  .q-sv-single-product-bottom-purchase {\n    position: absolute;\n    top: 5px;\n    left: 0;\n    display: flex !important;\n    flex-direction: row-reverse;\n    /* transform: translate(-50%, -50%) !important; */\n  }\n\n  .modal-form-single-item {\n    /* margin-bottom: 15px !important; */\n  }\n\n  .delivery-address-update-form {\n    /* margin-bottom: 15px; */\n    /* display:flex !important;\n    flex-wrap: wrap; */\n  }\n  .delivery-address-update-form-city-zipCode {\n    display: flex !important;\n    flex-wrap: wrap;\n  }\n  .modal-form-single-item-city {\n    margin: 0px 0px 15px 0px !important;\n    width: 100%;\n  }\n  .modal-form-single-item-zipcode {\n    width: 100%;\n  }\n\n  .q-sv-single-product-bottom-purchase {\n    position: absolute;\n    top: 0px;\n    left: 0;\n    display: flex !important;\n    flex-direction: row-reverse;\n    /* transform: translate(-50%, -50%) !important; */\n  }\n\n  .q-sv-single-product {\n    padding-top: 45px;\n    /* padding-bottom: 45px !important; */\n  }\n\n  .q-sv-single-product > .q-sv-single-product-bottom {\n    display: flex !important;\n    flex-direction: column-reverse;\n    /* margin-top: 20px; */\n  }\n\n  .q-sv-single-product > span {\n    position: absolute !important;\n    bottom: 67px !important;\n    top: unset !important;\n    margin-left: 10px;\n    height: 20px;\n    width: 60px;\n    font-size: 10px;\n    padding-top: 3px;\n  }\n\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-purchase\n    > Button {\n    width: 100px !important;\n    font-size: 11px;\n    background: none;\n    margin-left: 0 !important;\n    margin-right: -25px;\n    height: 36px !important;\n  }\n\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-purchase\n    > Button\n    p {\n    margin-left: 0;\n  }\n\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-purchase\n    > .product-qti-button {\n    width: 58%;\n    margin-right: 11px;\n    /* margin-top: 5px; */\n  }\n\n  .out-of-stock-btn {\n    margin-right: 10px !important;\n    margin-top: 5px !important;\n    border: 5px solid black;\n  }\n\n  .home-page-all-sections {\n    width: 94% !important;\n  }\n\n  .header_area_box {\n    width: 94% !important;\n  }\n\n  .media-scroller-upper {\n    margin-left: -25px !important;\n    padding-left: 25px !important;\n    margin-right: -25px !important;\n    padding-right: 25px !important;\n  }\n\n  .SingleStoreAllInformationPage .media-scroller-upper {\n    margin-right: 0 !important;\n  }\n\n  .q-sv-single-product > .q-sv-single-product-top {\n    width: 100% !important;\n    margin-top: 5px;\n  }\n\n  .q-sv-single-product > .q-sv-single-product-top > img {\n    height: 100%;\n  }\n\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-purchase\n    > .add-wish {\n    background: unset;\n  }\n\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-amount\n    > span {\n    font-size: 15px;\n  }\n\n  .q-sv-single-product > .q-sv-single-product-bottom > h1 {\n    font-size: 12px;\n  }\n\n  .quickvee-single-store-content-singleStore {\n    margin-left: 5px;\n  }\n\n  .quickvee-single-store-content-singleStore > span {\n    font-size: 20px;\n  }\n\n  .quickvee-single-store-content-singleStore > p {\n    font-size: clamp(12px, 0.05px + 3.1783vw, 16px) !important;\n  }\n\n  .single-store-sproductListing-section > section > span {\n    font-size: clamp(16px, 0.05px + 4.1783vw, 20px) !important;\n  }\n\n  .single-store-sproductListing-section {\n    margin-bottom: 20px;\n  }\n\n  .single-store-sproductListing-section > section {\n    margin-bottom: 5px;\n  }\n\n  .songleStoreSearchBar {\n    margin-top: -10px;\n    margin-left: -25px;\n    margin-right: -25px;\n  }\n\n  .q-sv-single-product-bottom-purchase\n    > .product-qti-button\n    > .add-remove-cart-btn {\n    background: #0a64f9 !important;\n    border: none !important;\n    padding: 4px 5px !important;\n  }\n\n  .single-product-card-add-btn {\n    background: #0a64f9 !important;\n    border: none !important;\n    padding: 14px 5px !important;\n    height: 28px;\n    border-radius: 4px;\n  }\n\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-purchase\n    > .product-qti-button {\n    height: auto;\n    width: 10px;\n    padding: 0px;\n    /* border: 1px solid #0a64f9; */\n    border: 0;\n  }\n\n  .select-box {\n    z-index: 1;\n  }\n\n  .product-in-category {\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .modal-view-full-hours-description > .full-hours-data > div > span {\n    font-size: clamp(5, 0.05px + 3.1783vw, 16px);\n  }\n\n  .modal-view-full-hours-description > .full-hours-data > div > p {\n    font-size: clamp(5px, 0.05px + 3.1783vw, 16px);\n  }\n\n  .modal-view-full-hours-description > .full-hours-data .view-hour-today p {\n    font-size: clamp(5px, 0.05px + 3.1783vw, 16px);\n    display: -webkit-inline-box;\n  }\n  .select-box__input-text {\n    font-size: clamp(8px, 0.05px + 3.1783vw, 16px) !important;\n  }\n\n  .select-box__option {\n    font-size: clamp(8px, 0.05px + 3.1783vw, 16px) !important;\n  }\n\n  .single-selectCategory-product-listing > .q-single-category-headings > span {\n    font-size: clamp(12px, 0.05px + 5.1783vw, 20px) !important;\n  }\n\n  .order-top-bar-search {\n    width: 100%;\n  }\n\n  /* #modal-view-full-hours-header {\n    position: sticky !important;\n    top: 0;\n    background-color: white;\n  } */\n\n  .topBarUserAndCartLogo {\n    display: flex !important;\n    flex-direction: row-reverse;\n    /* border: solid 1px red; */\n    justify-content: center !important;\n  }\n\n  .select-box {\n    width: 220px;\n  }\n\n  .quickvee-single-store-logo-singleStore a img {\n    height: 60px;\n    width: 60px;\n  }\n\n  .quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn {\n    margin: 0;\n    width: 100%;\n    padding: 10px;\n  }\n\n  .full-hours-data-detail > .single-full-hour-data-detail > img {\n    width: 50px;\n    height: 50px;\n  }\n\n  .full-hours-data-detail > .single-full-hour-data-detail > span {\n    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;\n    text-align: center;\n  }\n\n  .full-hours-data-detail > .single-full-hour-data-detail > p {\n    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;\n    text-align: center;\n    color: #232323;\n    font-size: 18px !important;\n    /* font-family: QuicksandBold !important; */\n    margin-left: 14px;\n    font-weight: 600;\n    font-family: Jost;\n    text-wrap-style: balance;\n  }\n\n  .modal-view-full-hours-description\n    > .full-hours-data-detail\n    > .single-full-hour-data-detail {\n    padding: 10px;\n  }\n\n  .order-side-bar-component {\n    top: 0;\n    z-index: 100;\n  }\n\n  .quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > a,\n  .quickvee-store-topbar-cart\n    > .quickvee-store-cart-checkout-btn\n    > .payment-checkout-with-login {\n    width: 100%;\n  }\n\n  .quickvee-store-topbar-cart {\n    padding-left: 10px;\n  }\n\n  .orderSummeryBannerContent {\n    right: unset !important;\n    left: 10%;\n    width: unset !important;\n    font-size: clamp(18px, 0.5px + 2.1783vw, 20px);\n  }\n\n  .OrderSummeryProductRTop h4 {\n    font-size: clamp(15px, 0.5px + 2.1783vw, 18px) !important;\n  }\n\n  .OrderSummeryProductRBottomL span {\n    font-size: clamp(18px, 0.5px + 2.1783vw, 20px) !important;\n  }\n\n  .orderSummeryRightTopC p {\n    margin-bottom: 12px !important;\n  }\n\n  .button-for-minamount-on-delivery {\n    width: 100%;\n  }\n\n  .full-hours-data-detail > .single-full-hour-data-detail > img {\n    width: 50px;\n    height: 50px;\n  }\n\n  .full-hours-data-detail > .single-full-hour-data-detail > span {\n    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;\n    text-align: center;\n  }\n\n  .full-hours-data-detail > .single-full-hour-data-detail > p {\n    font-size: clamp(8px, 0.5px + 2.1783vw, 14px) !important;\n    text-align: center;\n    color: #232323;\n    font-size: 18px !important;\n    /* font-family: QuicksandBold !important; */\n    margin-left: 14px;\n    font-weight: 600;\n    font-family: Jost;\n    text-wrap-style: balance;\n  }\n\n  .modal-view-full-hours-description\n    > .full-hours-data-detail\n    > .single-full-hour-data-detail {\n    padding: 10px;\n  }\n\n  .order-side-bar-component {\n    top: 0;\n    z-index: 100;\n  }\n\n  .quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > a {\n    width: 100%;\n  }\n\n  .quickvee-store-topbar-cart {\n    padding-left: 10px;\n  }\n\n  .orderSummeryBannerContent {\n    /* right: unset !important; */\n    /* left: 10%; */\n    width: 65% !important;\n    font-size: clamp(18px, 0.5px + 2.1783vw, 20px);\n  }\n\n  .orderSummeryBannerContent p {\n    font-size: 16px;\n  }\n\n  .OrderSummeryProductRTop h4 {\n    font-size: clamp(15px, 0.5px + 2.1783vw, 18px) !important;\n  }\n\n  .OrderSummeryProductRBottomL span {\n    font-size: clamp(18px, 0.5px + 2.1783vw, 20px) !important;\n  }\n\n  .orderSummeryRightTopC p {\n    margin-bottom: 12px !important;\n  }\n\n  .button-for-minamount-on-delivery {\n    width: 100%;\n  }\n}\n\n@media (max-width: 612px) {\n  .q-sv-single-product {\n    width: 100% !important;\n    height: 300px !important;\n  }\n}\n\n.add-btn-single-product {\n  /* margin-right: 5px; */\n  /* width: 30px; */\n\n  color: #efefef;\n  background-color: #0a64f9;\n  border-radius: 5px;\n  /* margin-top: 5px; */\n}\n\n.quickvee-single-store-logo-singleStore {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 420px) {\n  .quickvee-single-store-pickup-delivery {\n    width: 100%;\n  }\n\n  .quickvee-single-store-pickup-delivery > Button {\n    width: 180px;\n  }\n\n  .select-box {\n    width: 60%;\n  }\n\n  .modal-view-full-hours-description\n    > .full-hours-data-detail\n    > .single-full-hour-data-detail {\n    padding: 5px;\n  }\n}\n\n@media (max-width: 900px) {\n  .q-sv-single-product .single-p-select-variant-btn {\n    width: 70%;\n    padding: 0;\n  }\n}\n\n@media (max-width: 806px) {\n  .q-sv-single-product\n    > .q-sv-single-product-bottom\n    > .q-sv-single-product-bottom-purchase\n    > Button\n    p {\n    font-size: 14px !important;\n  }\n}\n@media (max-width: 480px) {\n  .StoreCredit-zone-detail-section {\n    padding-top: 0px;\n    padding-left: 0%;\n    padding-right: 0;\n  }\n\n  .single-store-sproductListing-section > section > div > a {\n    font-size: clamp(8px, 0.05px 2.1783vw, 16px) !important;\n    /* width: 90px !important; */\n    white-space: nowrap;\n  }\n\n  .account-info-main-component {\n    padding: 15px 0px;\n  }\n\n  .account-info-welcome-header {\n    margin: 0px 15px;\n  }\n\n  .account-info-subheading > p {\n    margin: 0px 15px;\n  }\n\n  .account-info {\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,\n      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n    border-radius: 0;\n    margin: 12px -2px;\n  }\n\n  .StoreCredit-zone-detail-section {\n    border: none;\n  }\n}\n\n/* @media (max-width:441px) {\n    .single-store-sproductListing-section>section>div>a {\n        font-size: 10px !important;\n    }\n} */\n\n.search-category-page-store-description {\n  /* width: auto !important; */\n  /* max-width: 170px !important; */\n  width: auto !important;\n}\n\n@media (max-width: 440px) {\n  .search-category-page-store-description > span {\n    font-size: 15px;\n  }\n\n  .search-category-page-store-description > p {\n    font-size: 10px;\n  }\n\n  .search-category-page-store-detail > .search-category-store-image-div {\n    margin-right: 6px;\n  }\n}\n\n.modal-view-full-hours-description {\n  overflow-y: auto;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  /* Semi-transparent black overlay */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.quickvee-single-store-offer-coupon {\n  /* width: 285px; */\n}\n\n.moble-cart-icon {\n  margin-top: 4px;\n  margin-left: 10px;\n  margin-right: 10px;\n  width: 28px;\n  /* margin-right: 20px !important; */\n}\n\n.css-106c1u2-MuiBadge-badge {\n  top: 9px !important;\n  right: 10px !important;\n}\n\n.quickvee-single-store-cart-button {\n  background: #fff !important;\n  border-radius: 6px !important;\n  color: #232323 !important;\n  cursor: pointer !important;\n  font-family: QuicksandBold !important;\n  font-size: 20px !important;\n  line-height: normal !important;\n  margin: 0 5px;\n  padding: 6px 20px !important;\n}\n\n.q-sv-single-product > .q-sv-single-product-top > img {\n  z-index: unset !important;\n}\n\n.quickvee-single-store-top-bar {\n  display: flex !important;\n  flex-wrap: nowrap;\n}\n\n.topBarUserAndCartLogo {\n  display: flex !important;\n  flex-wrap: nowrap !important;\n  flex-direction: row-reverse;\n}\n\n@media (max-width: 950px) {\n  .quickvee-single-store-offer-coupon {\n    margin: 0;\n  }\n\n  .order-top-bar-search {\n    width: unset !important;\n  }\n}\n\n.single-product-zoom-div > div > div {\n  /* background-size: 80% !important; */\n  /* background-position: 50% !important; */\n}\n\n@media (max-width: 1104px) {\n  .single-product-zoom-div > div > div {\n    background-size: 80% !important;\n    /* background-position: 50% !important; */\n  }\n\n  .quickvee-single-product-add-update > span {\n    margin: 0;\n  }\n\n  .quickvee-single-product-add-update > span {\n    width: 10%;\n  }\n\n  .quickvee-single-product-add-update {\n    /* margin-left: px !important; */\n  }\n\n  .quickvee-single-product-add-update > .single-patc-btn,\n  .quickvee-single-product-add-update > .single-patc-btn:hover {\n    padding: 5px 11px !important;\n  }\n}\n\n@media (max-width: 891px) {\n  .single-product-zoom-div > div > div {\n    background-size: 60% !important;\n    /* background-position: 50% !important; */\n  }\n\n  .quickvee-single-product-add-update > .single-patc-btn,\n  .quickvee-single-product-add-update > .single-patc-btn:hover {\n    margin: 0 10px !important;\n  }\n\n  .quickvee-single-product-detail-section {\n    margin-left: 0;\n  }\n}\n\n.quickvee-single-product-add-update > .single-patc-btn,\n.quickvee-single-product-add-update > .single-patc-btn:hover {\n  font-size: clamp(2px, 5px + 0.7783vw, 14px) !important;\n  /* margin: 0 10px; */\n}\n\n.single-product-single-features-selection > div > label {\n  font-size: clamp(12px, 1px + 1.1783vw, 14px) !important;\n}\n\n@media (max-width: 850px) {\n  .quickvee-single-product-add-update {\n    margin-left: 0px !important;\n    margin-right: -100px !important;\n  }\n}\n\n.css-106c1u2-MuiBadge-badge {\n  width: 20px;\n}\n\n@media (max-width: 480px) {\n  .account-info-welcome-header {\n    display: flex !important;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-items: flex-start !important;\n  }\n\n  .account-info-welcome-header p {\n    /* margin-left: auto; */\n\n    /* Add this line */\n  }\n}\n\n.account-info-main-component > .account-info-welcome-header > h1 {\n  font-size: clamp(15px, 2px + 4.1783vw, 25px) !important;\n}\n\n.css-1xhypcz-MuiStack-root > .MuiTextField-root {\n  padding-bottom: 5px !important;\n}\n\n#modal-modal-description {\n  padding-bottom: 70px;\n}\n.modal-Billinginfo {\n  padding-bottom: 80px !important;\n}\n\n#modal-modal-description::-webkit-scrollbar {\n  width: 3px;\n}\n\n/* Track */\n#modal-modal-description::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n\n  cursor: pointer;\n}\n\n/* Handle */\n#modal-modal-description::-webkit-scrollbar-thumb {\n  background: #3e85f8;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.3s ease-in-out;\n  outline: 1px solid #fff;\n}\n\n/* Handle on hover */\n#modal-modal-description::-webkit-scrollbar-thumb:hover {\n  background: #0a64f9;\n  cursor: pointer !important;\n}\n\n.basic-modal > .modal-forms > .modal-footer {\n  padding: 15px;\n  /* margin-left: 12px;\n  margin-right: 18px; */\n  background: white;\n  position: fixed !important;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n}\n\n@media (max-width: 490px) {\n  .quickvee-single-product-top-section {\n    display: flex !important;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .quickvee-single-product-top-section > div {\n    flex: 1;\n    /* Make the divs flexible to distribute space */\n    display: flex;\n    /* Nested flex container */\n  }\n\n  .quickvee-single-product-detail-section {\n    align-self: start !important;\n  }\n\n  .quickvee-single-product-image-section {\n    width: 100%;\n    /* margin-left: 10px; */\n    margin: 0;\n  }\n\n  .single-product-single-features-selection > div > label {\n    font-size: 18px !important;\n    padding: 7px 14px;\n  }\n\n  .quickvee-single-product-add-update {\n    margin-right: 0 !important;\n  }\n\n  .quickvee-single-product-add-update > .single-patc-btn,\n  .quickvee-single-product-add-update > .single-patc-btn:hover {\n    font-size: 13px !important;\n    margin: 0 20px !important;\n  }\n\n  .quickvee-single-product-single-features {\n    /* margin: -6px; */\n  }\n\n  .single-product-single-features-selection > div > input {\n    height: 0;\n  }\n\n  .quickvee-single-product-detail-section {\n    margin: 0;\n  }\n\n  .go-to-cart-btn {\n    padding: 10px 20px !important;\n  }\n}\n\n.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.MuiSelect-select {\n  min-height: 1.543em !important;\n}\n\n.discount-tag {\n  z-index: 1;\n}\n\n.id-type-billinginfo {\n  height: 3.1rem !important;\n  margin-top: 1px !important;\n}\n\n.password-title-accountinfo {\n  text-transform: capitalize;\n  color: #212121;\n  font-size: 16px;\n  font-family: QuicksandBold, 'Quicksand' !important;\n}\n\n.last-change-password-p {\n  text-transform: capitalize;\n  color: #707070 !important;\n  font-size: 12px;\n  font-family: QuicksandSemiBold, 'Quicksand' !important;\n}\n\n.date-of-birth-div {\n  margin-bottom: 0 !important;\n}\n\n@media (max-width: 420px) {\n  .out-of-stock-btn {\n    height: 36px !important;\n  }\n}\n\n.dropdown-container > button {\n  background-color: white !important;\n  border: none !important;\n}\n.DropDown-menu-container {\n  border-radius: 8px;\n  box-shadow: 0px 6px 15px #0a64f94d;\n  padding: 0 !important;\n}\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.error_banner_area {\n  width: 100%;\n  height: 100%;\n  background: url('./../Assets/PageNotFoundImages/banner_bg.webp');\n  background-size: cover;\n  background-position: bottom;\n  position: relative;\n  background-repeat: no-repeat;\n  min-height: calc(100vh - 0px);\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .error_banner_area {\n  }\n}\n\n.error_banner_left {\n  width: 20%;\n  height: auto;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  background: url('./../Assets//PageNotFoundImages/banner_left.webp');\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.error_banner_right {\n  width: 20%;\n  height: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: url('./../Assets/PageNotFoundImages/banner_right.webp');\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.error_banner_center {\n  width: 40%;\n  height: auto;\n  margin: 0 auto;\n  /* padding-top: 13%; */\n  text-align: center;\n}\n\nelement.style {\n  filter: invert(0);\n}\n.error_banner_center img {\n  width: 40%;\n  height: auto;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1280px) {\n  .error_banner_left,\n  .error_banner_right {\n    width: 23%;\n  }\n}\n@media (max-width: 991px) {\n  .error_banner_left {\n    background-position: right;\n  }\n  .error_banner_right {\n    background-position: left;\n  }\n  .error_banner_center {\n    width: 50%;\n  }\n}\n\n@media (max-width: 480px) {\n  .error_banner_left,\n  .error_banner_right {\n    width: 36%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
